import { render } from "./SpecialProcess.vue?vue&type=template&id=be9021f6&scoped=true"
import script from "./SpecialProcess.vue?vue&type=script&lang=js"
export * from "./SpecialProcess.vue?vue&type=script&lang=js"

import "./SpecialProcess.vue?vue&type=style&index=0&id=be9021f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9021f6"]])

export default __exports__